import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableExtraPay extends Layout {
    sourceExtraPay: DataSource;
    tableExtraPay: Table;
}
